/*
    Here are collected a few utilities shared among reports' editing and
    rendering
*/

import utils from './utils';

class ReportUtils {
    formatDateOptions()
    {
        let start = null;
        let end = null;
        let interval = null;

        let wrapper = $('#date-range-calendar');
        if (wrapper.length) {
            start = wrapper.attr('data-start');
            end = wrapper.attr('data-end');
            interval = wrapper.attr('data-interval');
        }
        else {
            interval = $('select[name=interval]').val();
        }

        if (interval != '') {
            return '?interval=' + interval;
        }
        else {
            return '?start=' + start + '&end=' + end;
        }
    }

    loadCell(cell, mode, subject)
    {
        let widget_id = cell.attr('data-widget-id');

        if (widget_id != 'undefined') {
            let static_mode = cell.attr('data-static');
            cell.empty().addClass('loading-widget').append('<div class="spinner-border" role="status"></div>');

            let url = '';

            if (mode == 'passive') {
                url = '/admin/widgets/show/passive/' + widget_id;
            }
            else {
                url = '/admin/widgets/show/' + mode + '/' + widget_id + '/' + subject + this.formatDateOptions();
            }

            if (static_mode == 'true') {
                url += '&static=1';
            }

            $.ajax({
                url: url,
                method: 'GET',
                dataType: 'HTML',
                success: (data) => {
                    data = $(data);
                    cell.closest('.grid-stack-item-content').addClass('widget');
                    cell.replaceWith(data);
                    utils.j().initElements(data);
                    data.trigger('widget_loaded');
                }
            });

            return true;
        }
        else {
            return false;
        }
    }

    loadCells(grid, container, mode, subject)
    {
        $('.grid-stack .grid-stack-item-content [data-widget-id]', container).each((index, cell) => {
            cell = $(cell);

            let test = this.loadCell(cell, mode, subject);
            if (test == false) {
                /*
                    This is to remove non-inited cells (e.g. when adding a
                    new cell and abandoning the page without adding a new
                    widget)
                */
                grid.removeWidget(cell.closest('.grid-stack-item').get(0));
            }
        });

        if (mode != 'passive') {
            let cell = $('#report-header');
            let url = cell.attr('data-url') + this.formatDateOptions();

            $.ajax({
                url: url,
                method: 'GET',
                dataType: 'HTML',
                success: (data) => {
                    data = $(data);
                    cell.replaceWith(data);
                }
            });
        }
    }
}

export default ReportUtils;
